function simulateApiRequest(responseData: any, delay: number): Promise<any> {
  return new Promise((resolve) => {
    setTimeout(() => {
      resolve(responseData);
    }, delay);
  });
}

function simulateApiError(errorMessage: string, delay: number): Promise<never> {
  return new Promise((_resolve, reject) => {
    setTimeout(() => {
      reject(new Error(errorMessage));
    }, delay);
  });
}

export { simulateApiError, simulateApiRequest };
